// extracted by mini-css-extract-plugin
export var navItemBlog = "navigation-module--navItemBlog--MPl1d";
export var navItem = "navigation-module--navItem--DZsRL";
export var navItemSelected = "navigation-module--navItemSelected--tS8a0";